
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class WindWhirlsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (300 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const speed = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = (1 / layerIndex) * scale;

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = this.pseudoRandom(x) * spacing;
                const offY = this.pseudoRandom(y) * spacing;
                const r = (50 + this.pseudoRandom(x * y) * 50) * scale;
                const rot = speed * (1 + this.pseudoRandom(x) * 2);
                
                const draw = () => {
                    ctx.save();
                    ctx.translate(x + offX, y + offY);
                    ctx.rotate(rot);
                    ctx.beginPath();
                    for (let a = 0; a < Math.PI * 2; a += 0.2) {
                        const curR = r * (a / (Math.PI * 2));
                        const px = Math.cos(a) * curR;
                        const py = Math.sin(a) * curR;
                        if (a === 0) ctx.moveTo(px, py);
                        else ctx.lineTo(px, py);
                    }
                    ctx.stroke();
                    ctx.restore();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
